/**
 * @returns {[[string, string]]}
 */
export default function groupFormEntries(entries) {
  const groupedArray = entries
    .reduce((acc, [name, value]) => {
      (acc[name] = acc[name] || []).push(value);
      return acc;
    }, {});

  const groupedObject = Object.entries(groupedArray)
    .map(([key, value]) => [key, value.join(',')])
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  return groupedObject;
}



// WEBPACK FOOTER //
// ./src/utils/form/groupFormEntries.js